import { render, staticRenderFns } from "./N11Kategori.vue?vue&type=template&id=0b4bb289&scoped=true"
import script from "./N11Kategori.vue?vue&type=script&lang=js"
export * from "./N11Kategori.vue?vue&type=script&lang=js"
import style0 from "./N11Kategori.vue?vue&type=style&index=0&id=0b4bb289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4bb289",
  null
  
)

export default component.exports